// Import controller
import deleteTimelineTaskCTRL from 'controllers/timeline/deleteTimelineTask'
import { alert } from 'util/alert';

// import {fetchAnnouncementList} from './getAnnouncementList'
// Actions
export const START_DELETE_TIMELINE_TASK = 'START_DELETE_TIMELINE_TASK';
export const SUCCESS_DELETE_TIMELINE_TASK = 'SUCCESS_DELETE_TIMELINE_TASK';


// Action Creator
export function deleteTimelineTask(index, taskId, callback){
  return function(dispatch) {

    dispatch({
      type: START_DELETE_TIMELINE_TASK,
      payload: {
        deleting: true,
        index,
      }
    })

    deleteTimelineTaskCTRL(taskId)
    .then((result) => {
      dispatch({
        type: SUCCESS_DELETE_TIMELINE_TASK,
        payload: {...result, deleting: false}
      })

      if(typeof(callback) == 'function'){
        callback()
      }

    })
    .catch((err)  => {
      console.log(err)
      alert.warning("API CALL FAILED: Net error")
      .then(() => {
        window.location.reload();
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/template/Docks/StudentInfo/Timeline/redux/actions/deleteTimelineTask.js